import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Dialog, {DialogContent} from 'material-ui/Dialog'

import styles from '../styles'
import {steps} from '../reducers/orchestrator'

import StepStart from '../containers/start'
import StepReservation from '../containers/reservation'
import StepDelivery from '../containers/delivery'
import StepPickup from '../containers/pickup'
import StepAddress from '../containers/address'
import StepReview from '../containers/review'
import StepPayment from '../containers/payment'

class Rent extends React.Component {

  render() {
    const {step, setStep} = this.props
    return (
      <Dialog onClose={() => setStep(steps.NONE)} open={step !== steps.NONE} maxWidth="xs" fullWidth>
        <DialogContent>
          {step === steps.START ? <StepStart/> : null}
          {step === steps.RESERVATION ? <StepReservation/> : null}
          {step === steps.DELIVERY ? <StepDelivery/> : null}
          {step === steps.PICKUP ? <StepPickup/> : null}
          {step === steps.ADDRESS ? <StepAddress/> : null}
          {step === steps.PAYMENT ? <StepPayment/> : null}
          {step === steps.REVIEW ? <StepReview/> : null}
        </DialogContent>
      </Dialog>
    )
  }

  static propTypes = {
    step: PropTypes.string.isRequired,
    setStep: PropTypes.func.isRequired,
  }
}

export default withStyles(styles, {withTheme: true})(Rent)



// WEBPACK FOOTER //
// ./src/sections/rent/components/orchestrator.js